/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Platform_Closing_BodyInputs */

const en_platform_closing_body = /** @type {(inputs: Platform_Closing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Free while you are getting going, and nothing to install. Your first booking can be this afternoon.`)
};

const pl_platform_closing_body = /** @type {(inputs: Platform_Closing_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bezpłatnie na start i nic do instalowania. Pierwszą rezerwację możesz mieć jeszcze dziś.`)
};

/**
* | output |
* | --- |
* | "Free while you are getting going, and nothing to install. Your first booking can be this afternoon." |
*
* @param {Platform_Closing_BodyInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const platform_closing_body = /** @type {((inputs?: Platform_Closing_BodyInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Platform_Closing_BodyInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_platform_closing_body(inputs)
	return en_platform_closing_body(inputs)
});